import type { CourseCategoryShallow } from "@brookbush/types";

import { useRouter } from "next/compat/router";
import Link from "next/link";
import { useQueryState } from "next-usequerystate";

import Accordion from "~/components/Accordion";
import { constructQueryString } from "~/utils/helpers";

interface CoursesCatalogueItemProps {
	category: CourseCategoryShallow;
}

const CoursesCatalogueItem = ({ category }: CoursesCatalogueItemProps) => {
	const { slugs } = (useRouter()?.query ?? {}) as {
		slugs?: string[];
	};

	const [accreditationFilter] = useQueryState("accreditation");

	const queryString = constructQueryString([
		{
			value: accreditationFilter,
			key: "accreditation",
		},
	]);

	const isCurrentCategory = slugs?.[0] === category.slug;

	return (
		<div className="course-category">
			<Link
				scroll
				href={
					isCurrentCategory && slugs.length === 1
						? `/courses${queryString}`
						: `/courses/categories/${category.slug}${queryString}`
				}
			>
				<Accordion.Button
					hasChildren={!!category.subCategories?.length}
					isSelected={isCurrentCategory}
					isOpen={isCurrentCategory && slugs?.length === 2}
				>
					{category.title}
				</Accordion.Button>
			</Link>

			<Accordion.Panel isOpen={isCurrentCategory}>
				<div className="flex flex-col gap-1.5">
					{category.subCategories?.map((subCategory) => (
						<Link
							scroll
							key={subCategory.slug}
							href={
								slugs?.[1] === subCategory.slug
									? `/courses/categories/${category.slug}${queryString}`
									: `/courses/categories/${category.slug}/${subCategory.slug}${queryString}`
							}
						>
							<Accordion.Button isSelected={slugs?.[1] === subCategory.slug}>
								{subCategory.title}
							</Accordion.Button>
						</Link>
					))}
				</div>
			</Accordion.Panel>
		</div>
	);
};

export default CoursesCatalogueItem;
